window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
window.Cookies = require('js-cookie');
require('bootstrap-sass');
require('magnific-popup');
require('slick-carousel');

window.swal = require('sweetalert2');

window.axios = require('axios');

// Use shared axios configuration
import { setupAxios } from './config/axios';
setupAxios();
